import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    jsUrl: String
  }

  connect() {
    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const script = document.createElement('script');
          script.src = this.jsUrlValue;
          script.type = 'module';
          document.body.appendChild(script);
          script.onload = () => {
            document.dispatchEvent(new CustomEvent("JsLazyLoadingLoaded:" + this.jsUrlValue));
          };
          observer.disconnect();
        }
      });
    });
    observer.observe(this.element);
  }
}
